import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useInputChange } from '../../../../hooks'
import { Transfer } from 'antd';

import './ChurchAdmin.scss'

const ChurchAdmin = ({ api, church }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [banner, setBanner] = useState(church.banner)
    const [churchAdmins, setChurchAdmins] = useState(church.churchAdmins)
    const [churchUsers, setChurchUsers] = useState([])
    const [input, handleInputChange] = useInputChange()
    const [error, setError] = useState(null)
    const { t } = useTranslation()


    useEffect(() => {
        async function getChurchUsers(){
            const users = await api.getUsers(church.id)
            const transferUsers = users.map( u => {
                u.key = u.id;
                return u;
            });
            church.users = transferUsers
            setChurchUsers(transferUsers)
            setIsLoading(false)
        }

        getChurchUsers()
    }, [church])

    const handleBannerChange = (e) => {
        const { files } = e.target
        if (files[0]) {
            input.banner = files[0]
            const fr = new FileReader();
            fr.onload = function () {
                setBanner(fr.result)
            }
            fr.readAsDataURL(files[0]);
        }
    }

    const saveChurch = async () => {
        setIsLoading(true)
        try {
            const { error, ...result } = await api.updateChurch(church.id, input)
            if (error) {
                setError(error)
            }
        }
        catch(err){
            console.error(err)
            setError(err.message)
        }
        setIsLoading(false)
    }

    const onTransferChange = async (movedUsers) => {
        setIsLoading(true)
        try {
            const { error, ...result } = await api.updateChurch(church.id, { churchAdmins: movedUsers.filter( x => x != "" ) })
            if (error){
                setError(error)
            }
            else setChurchAdmins(movedUsers)
        }
        catch(err){
            console.error(err)
            setError(err.message)
        }
        setIsLoading(false)
    }

    return (
        <fieldset class="root" disabled={isLoading}>
            <div class="field">
                <label class="label">{t('church_admin.name')}</label>
                <div class="control">
                    <input class="input" type="text" name="name" defaultValue={church.name} onChange={handleInputChange} />
                </div>
            </div>
            
            <div class="field">
                <label class="label">{t('church_admin.address')}</label>
                <div class="control">
                    <input class="input" type="text" name="address" defaultValue={church.address} onChange={handleInputChange} />
                </div>
            </div>

            <div class="field">
                <label class="label">{t('church_admin.description')}</label>
                <div class="control">
                    <textarea class="textarea" name="description" defaultValue={church.description} onChange={handleInputChange}></textarea>
                </div>
            </div>

            <div class="field social-fields">
                <label class="label">{t('church_admin.social_media')}</label>
                <div class="control">
                    <i class="fab fa-facebook-square fa-2x"></i>
                    <input class="input" type="text" name="facebook" placeholder="Facebook" defaultValue={church.facebook} onChange={handleInputChange} />
                </div>
                <div class="control">
                    <i class="fab fa-twitter-square fa-2x"></i>
                    <input class="input" type="text" name="twitter" placeholder="Twitter" defaultValue={church.twitter} onChange={handleInputChange} />
                </div>
                <div class="control">
                    <i class="fab fa-instagram-square fa-2x"></i>
                    <input class="input" type="text" name="instagram" placeholder="Instagram" defaultValue={church.instagram} onChange={handleInputChange} />
                </div>
            </div>

            <div class="box churchAdmins">
                <label class="label">{t('church_admin.add_remove_admin_title')}</label>
                <p class="help">{t('church_admin.add_remove_admin_desc')}</p>
                <br />
                <Transfer
                    dataSource={churchUsers}
                    showSearch
                    showSelectAll={false}
                    listStyle={{
                        width: 250,
                        height: 300,
                    }}
                    targetKeys={churchAdmins}
                    onChange={onTransferChange}
                    render={item => `${item.firstName} ${item.lastName}` }
                />
            </div>


            <div class="field">
                <label class="label">{t('church_admin.church_banner')}</label>
                { banner ? <img class="bannerImage" src={banner} /> : <p>{t('church_admin.no_banner_found')}</p> }
                <div class="file has-name">
                    <label class="file-label">
                        <input class="file-input" type="file" name="banner" onChange={handleBannerChange} />
                        <span class="file-cta">
                            <span class="file-icon">
                                <i class="fas fa-upload"></i>
                            </span>
                            <span class="file-label">
                                {t('church_admin.choose_file')}
                            </span>
                        </span>
                    </label>
                </div>
            </div>

            { error && <p class="has-text-danger">{error}</p> }

            <div class="field is-grouped">
                <div class="control">
                    <button class="button is-success" onClick={saveChurch}>{t('church_admin.save')}</button>
                </div>
            </div>

        </fieldset>
    )
}

export default ChurchAdmin